import { Component } from "@angular/core";
import { AuthService } from "../../../app/auth/auth.service";
import { NavigationService } from "../../../navigation/navigation.service";
import { MobileUtilsProvider } from "../../../providers/mobile-utils/mobile-utils";

/**
 * Generated class for the HomePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: "page-home",
  templateUrl: "home.html",
})
export class HomePage {
  showLoading: boolean;

  constructor(
    private authSvc: AuthService,
    public navSvc: NavigationService,
    public mobileUtils: MobileUtilsProvider
  ) {
    this.showLoading = false;
  }

  ionViewCanEnter() {
    // if (this.authSvc.authenticated(true)) {
    this.navSvc.goToInternalPage("dashboard-page", null);
    // }
  }

  ionViewDidLoad() {
    // if (this.mobileUtils.isMobilePlatform()) {
    //     // Redirect to 'LoginCallbackPage' is not needed for Mobile App, It is handled in auth.service.mobileAuth method
    //     return;
    // }
    // if (this.authSvc.isLoggedIn()) {
    //     if (this.authSvc.authenticated(true)) {
    //         this.navSvc.goToInternalPage('LoginCallbackPage', {});
    //     }
    // }
  }

  ionViewDidEnter() {
    // if (this.mobileUtils.isMobilePlatform()) {
    //     setTimeout(() => { this.showLoading = true; }, 3000);
    //     return;
    // }
    // if (this.authSvc.isLoggedIn()) {
    //     if (this.authSvc.authenticated(true)) {
    //         this.navSvc.goToInternalPage('LoginCallbackPage', {});
    //     }
    // }
  }

  login() {
    this.authSvc.authenticated();
  }
}



// WEBPACK FOOTER //
// ./src/pages/common/home/home.ts